export default __webpack_public_path__ + "static/media/insta-1.8da45a47.svg";